// test2643
(2643 && 0);
